module.exports = __webpack_public_path__ + "static/img/氨解仪.017eb46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/仪器设备/氨解仪.png
// module id = okfz
// module chunks = 16